export default __webpack_public_path__ + "img/a9e11de6f3e756b525ab2c2d2275e708.mp4";